import useCartStore from "../../utils/cartStore";
import { useState } from "react";
import GuidePoster from "../GuidePoster";

const GOUTS = [
  { id: "praline-royal",   label: "Praliné Royal",   image: "/images/gouts_roses/praline-royal.png" },
  { id: "nuit-gourmand",   label: "Nuit Gourmand",   image: "/images/gouts_roses/nuit-gourmand.png" },
  { id: "neige-croquante", label: "Neige Croquante", image: "/images/gouts_roses/neige-croquante.png" },
  { id: "rose-orient",     label: "Rose d'Orient",   image: "/images/gouts_roses/rose-orient.png" },
  { id: "coeur-lait-pistache",          label: "Cœur de Lait Cœur Pistache",       image: "/images/gouts_roses/coeur-lait-pistache.png" },
  { id: "coeur-lait-praline-noisette",  label: "Cœur de Lait Praliné Noisette",    image: "/images/gouts_roses/coeur-lait-praline-noisette.png" },
];

const REPARTITION_VIDE = Object.fromEntries(GOUTS.map((g) => [g.id, 0]));

const EMBALLAGES = {
  bouquet: [
    { id: "blanc-noir",      label: "Blanc / Noir",     color: "#FFFFFF", accent: "#1a1a1a" },
    { id: "noir-dore",       label: "Noir / Doré",      color: "#1a1a1a", accent: "#D4AF37" },
    { id: "noir",            label: "Noir",              color: "#1a1a1a", accent: "#1a1a1a" },
    { id: "blanc-dore",      label: "Blanc / Doré",     color: "#FFFFFF", accent: "#D4AF37" },
    { id: "blanc",           label: "Blanc",             color: "#FFFFFF", accent: "#FFFFFF" },
    { id: "rose-dore",       label: "Rose / Doré",      color: "#FFB6C1", accent: "#D4AF37" },
    { id: "mauve-dore",      label: "Mauve / Doré",     color: "#C8A2C8", accent: "#D4AF37" },
    { id: "brun",            label: "Brun",              color: "#6F4E37", accent: "#6F4E37" },
  ],
  boite: [
    { id: "blanc", label: "Blanc", color: "#FFFFFF" },
    { id: "noir",  label: "Noir",  color: "#1a1a1a" },
    { id: "rose",  label: "Rose",  color: "#F4A7B9" },
  ],
  sac: [
    { id: "blanc", label: "Blanc", color: "#FFFFFF" },
    { id: "rose",  label: "Rose",  color: "#F4A7B9" },
    { id: "noir",  label: "Noir",  color: "#1a1a1a" },
  ],
};

const LABELS_EMBALLAGE = {
  bouquet: "Couleur d'emballage",
  boite:   "Couleur de la boîte",
  sac:     "Couleur du sac",
};

const EmballageSelector = ({ type, selected, onSelect }) => {
  const options = EMBALLAGES[type];
  const label = LABELS_EMBALLAGE[type];
  return (
    <div className="mb-4">
      <p className="text-sm font-semibold mb-2 text-gray-700">{label} :</p>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => {
          const isSelected = selected?.id === opt.id;
          return (
            <button
              key={opt.id}
              onClick={() => onSelect(opt)}
              className={`flex items-center gap-2 px-2 py-1 rounded-lg border text-xs transition-all ${
                isSelected
                  ? "border-primary ring-2 ring-primary ring-offset-1"
                  : "border-gray-200 hover:border-gray-400"
              }`}
            >
              <span className="w-5 h-5 rounded-full flex-shrink-0 border border-gray-200" style={{ background: opt.color }} />
              {opt.accent && opt.accent !== opt.color && (
                <span className="w-2 h-2 rounded-full flex-shrink-0 -ml-1" style={{ background: opt.accent }} />
              )}
              <span className="text-gray-700">{opt.label}</span>
            </button>
          );
        })}
      </div>
      {!selected && <p className="text-xs text-amber-600 mt-1">Veuillez choisir un emballage</p>}
    </div>
  );
};

const FloralProductCard = ({ product }) => {
  const addToCart = useCartStore((state) => state.addToCart);
  const [quantity, setQuantity] = useState(1);
  const [repartition, setRepartition] = useState({ ...REPARTITION_VIDE });
  const [pivoineGout, setPivoineGout] = useState(null);
  const [emballage, setEmballage] = useState(null);
  const [demandeParticuliere, setDemandeParticuliere] = useState("");

  const maxRoses = product.roses;
  const totalRoses = Object.values(repartition).reduce((a, b) => a + b, 0);
  const restant = maxRoses - totalRoses;
  const rosesPret = totalRoses === maxRoses;
  const pivoinePret = product.hasPivoine ? pivoineGout !== null : true;
  const pret = rosesPret && pivoinePret && emballage !== null;

  const handleIncrease = (goutId) => {
    if (restant <= 0) return;
    setRepartition((prev) => ({ ...prev, [goutId]: prev[goutId] + 1 }));
  };

  const handleDecrease = (goutId) => {
    if (repartition[goutId] <= 0) return;
    setRepartition((prev) => ({ ...prev, [goutId]: prev[goutId] - 1 }));
  };

 const buildDescription = () => {
  const roses = GOUTS.filter((g) => repartition[g.id] > 0)
    .map((g) => `${repartition[g.id]}x ${g.label}`)
    .join(", ");
  const pivoine = product.hasPivoine && pivoineGout
    ? `\nPivoine : ${pivoineGout.label}`
    : "";
  const emb = emballage ? `\nEmballage : ${emballage.label}` : "";
  const demande = demandeParticuliere.trim()
    ? `\nDemande : ${demandeParticuliere.trim()}`
    : "";
  return roses + pivoine + emb + demande;
};

  const handleAddToCart = () => {
    if (!pret) return;
    addToCart(
      {
        id: product.id,
        name: product.name,
        price: product.price,
        image: product.image || "/images/placeholder.jpg",
        category: "Créations Florales",
        description: buildDescription(),
      },
      quantity
    );
    setRepartition({ ...REPARTITION_VIDE });
    setPivoineGout(null);
    setEmballage(null);
    setDemandeParticuliere("");
    setQuantity(1);
  };

  return (
    <div className="bg-white rounded-2xl shadow p-6">
      <img
        src={product.image || "/images/placeholder.jpg"}
        alt={product.name}
        className="w-full h-56 object-cover rounded-xl mb-4"
      />
      <h2 className="text-xl font-semibold mb-1">{product.name}</h2>
      <p className="text-gray-500 text-sm mb-3">{product.description}</p>
      <p className="text-lg font-bold mb-4">{product.price} €</p>

      {/* Goûts des roses */}
      <div className="mb-4">
        <p className="text-sm font-semibold mb-2 text-gray-700">
          Choisissez vos {maxRoses} roses :
        </p>
        <GuidePoster image="/images/guides/guide-gouts.jpg" label="Voir le guide des goûts" />
        <div className={`text-xs font-medium mb-3 px-3 py-1 rounded-full inline-block ${
          rosesPret ? "bg-green-100 text-green-700" : "bg-amber-100 text-amber-700"
        }`}>
          {rosesPret ? "✓ Sélection complète !" : `${restant} rose${restant > 1 ? "s" : ""} restante${restant > 1 ? "s" : ""}`}
        </div>
        <div className="space-y-2">
          {GOUTS.map((gout) => {
            const count = repartition[gout.id];
            const canAdd = restant > 0;
            return (
              <div key={gout.id} className="flex items-center gap-3">
                <img src={gout.image} alt={gout.label} className="w-10 h-10 rounded-lg object-cover flex-shrink-0" />
                <span className="text-sm text-gray-700 flex-1">{gout.label}</span>
                <div className="flex items-center gap-2">
                  <button onClick={() => handleDecrease(gout.id)} disabled={count === 0}
                    className={`w-7 h-7 rounded border text-sm font-bold transition-colors ${count === 0 ? "border-gray-200 text-gray-300 cursor-not-allowed" : "border-gray-400 text-gray-700 hover:border-primary hover:text-primary"}`}>−</button>
                  <span className="w-5 text-center text-sm font-semibold">{count}</span>
                  <button onClick={() => handleIncrease(gout.id)} disabled={!canAdd}
                    className={`w-7 h-7 rounded border text-sm font-bold transition-colors ${!canAdd ? "border-gray-200 text-gray-300 cursor-not-allowed" : "border-gray-400 text-gray-700 hover:border-primary hover:text-primary"}`}>+</button>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Goût de la pivoine */}
      {product.hasPivoine && (
        <div className="mb-4">
          <p className="text-sm font-semibold mb-2 text-gray-700">
            Goût de la Fleur Pivoine :
          </p>
          <div className="flex flex-wrap gap-2">
            {GOUTS.map((gout) => (
              <button
                key={gout.id}
                onClick={() => setPivoineGout(gout)}
                className={`flex items-center gap-2 px-2 py-1 rounded-lg border text-xs transition-all ${
                  pivoineGout?.id === gout.id
                    ? "border-primary ring-2 ring-primary ring-offset-1"
                    : "border-gray-200 hover:border-gray-400"
                }`}
              >
                <img src={gout.image} alt={gout.label} className="w-5 h-5 rounded object-cover" />
                <span className="text-gray-700">{gout.label}</span>
              </button>
            ))}
          </div>
          {!pivoineGout && (
            <p className="text-xs text-amber-600 mt-1">Veuillez choisir le goût de la pivoine</p>
          )}
        </div>
      )}

      {/* Emballage */}
      <EmballageSelector
        type={product.emballageType}
        selected={emballage}
        onSelect={setEmballage}
      />

      {/* Demande particulière */}
      <div className="mb-4">
        <p className="text-sm font-semibold mb-2 text-gray-700">
          Demande particulière <span className="text-gray-400 font-normal">(optionnel)</span> :
        </p>
        <GuidePoster image="/images/guides/guide-toppers.jpg" label="Voir des exemples de toppers" />
        <input
          type="text"
          value={demandeParticuliere}
          onChange={(e) => setDemandeParticuliere(e.target.value)}
          placeholder="Ex : topper anniversaire, bébé garçon, prénom..."
          className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-primary"
        />
      </div>

      {/* Quantité */}
      <div className="flex items-center gap-3 mb-4">
        <button onClick={() => setQuantity(Math.max(1, quantity - 1))} className="w-8 h-8 border rounded">−</button>
        <span>{quantity}</span>
        <button onClick={() => setQuantity(quantity + 1)} className="w-8 h-8 border rounded">+</button>
      </div>

      <button
        onClick={handleAddToCart}
        disabled={!pret}
        className={`w-full py-2 rounded-xl font-semibold transition-colors ${
          pret ? "btn-primary cursor-pointer" : "bg-gray-200 text-gray-400 cursor-not-allowed"
        }`}
      >
        {!rosesPret ? "Complétez votre sélection de roses"
          : !pivoinePret ? "Choisissez le goût de la pivoine"
          : !emballage ? "Choisissez un emballage"
          : "Ajouter au panier"}
      </button>
    </div>
  );
};

export default FloralProductCard;